import type { Person } from "../api/types";

export type PersonEditorState = {
  mode: "add" | "edit";
  id?: number;
  display_name: string;
  email: string;
  phone: string;
  role: string;
  password: string;
  is_active: boolean;
};

export function emptyPersonEditor(): PersonEditorState {
  return {
    mode: "add",
    display_name: "",
    email: "",
    phone: "",
    role: "surgeon",
    password: "",
    is_active: true,
  };
}

export function editorFromPerson(p: Person): PersonEditorState {
  return {
    mode: "edit",
    id: p.id,
    display_name: p.display_name,
    email: p.email,
    phone: p.phone || "",
    role: p.role,
    password: "",
    is_active: p.is_active,
  };
}

type Props = {
  editor: PersonEditorState;
  busy: boolean;
  onChange: (next: PersonEditorState) => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete?: () => void;
};

export function PersonEditor({ editor, busy, onChange, onSave, onCancel, onDelete }: Props) {
  return (
    <div className="people-editor" role="dialog" aria-label={editor.mode === "add" ? "Add person" : "Edit person"}>
      <div className="people-editor-head">
        <h3>{editor.mode === "add" ? "Add person" : "Edit person"}</h3>
        <button type="button" className="people-close" aria-label="Close" onClick={onCancel}>
          ✕
        </button>
      </div>
      <div className="people-form-grid">
        <label>
          Name
          <input
            value={editor.display_name}
            onChange={(e) => onChange({ ...editor, display_name: e.target.value })}
          />
        </label>
        <label>
          Email
          <input
            type="email"
            value={editor.email}
            onChange={(e) => onChange({ ...editor, email: e.target.value })}
          />
        </label>
        <label>
          Phone
          <input
            value={editor.phone}
            onChange={(e) => onChange({ ...editor, phone: e.target.value })}
            placeholder="(407) …"
          />
        </label>
        <label>
          Role
          <select value={editor.role} onChange={(e) => onChange({ ...editor, role: e.target.value })}>
            <option value="surgeon">surgeon</option>
            <option value="circulator">circulator</option>
            <option value="admin">admin</option>
          </select>
        </label>
        <label>
          {editor.mode === "add" ? "Password (optional)" : "New password (optional)"}
          <input
            type="password"
            value={editor.password}
            onChange={(e) => onChange({ ...editor, password: e.target.value })}
            placeholder="min 8 chars"
            autoComplete="new-password"
          />
        </label>
        {editor.mode === "edit" && (
          <label className="people-check">
            <input
              type="checkbox"
              checked={editor.is_active}
              onChange={(e) => onChange({ ...editor, is_active: e.target.checked })}
            />
            Active
          </label>
        )}
      </div>
      <div className="people-editor-actions">
        <button type="button" className="primary" disabled={busy} onClick={onSave}>
          Save
        </button>
        <button type="button" className="cancel" onClick={onCancel}>
          Cancel
        </button>
        {editor.mode === "edit" && onDelete && (
          <button type="button" className="danger-btn" onClick={onDelete}>
            Delete
          </button>
        )}
      </div>
    </div>
  );
}
